<div class="toggle-view">
  <button
    class="btn"
    [ngClass]="{ 'is-active': userType() === userTypeEnum.BUSINESS }"
    (click)="setUserType(userTypeEnum.BUSINESS, userType())"
  >
    @if (mdAndBelow()) {
      <fa-icon [icon]="getMobileIcon()" class="mobile-flag"></fa-icon>
    }
    {{ 'header.view.business' | transloco }}
  </button>
  <div class="toggle-view__divider">|</div>
  <button
    class="btn"
    [ngClass]="{ 'is-active': userType() === userTypeEnum.INDIVIDUAL }"
    (click)="setUserType(userTypeEnum.INDIVIDUAL, userType())"
  >
    {{ 'header.view.individual' | transloco }}
  </button>
</div>
